import { render, staticRenderFns } from "./DialogDetailPetition.vue?vue&type=template&id=26383d2b&"
import script from "./DialogDetailPetition.vue?vue&type=script&lang=js&"
export * from "./DialogDetailPetition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports